import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {BadgeTypeFactoryService} from 'shared/badges/services/badge-type-factory.service';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalConfirmationModule} from '../../../shared/modals/modal-confirmation/modal-confirmation.module';
import {BadgesOverviewRoutingModule} from './badges-overview-routing.module';
import {BadgesOverviewComponent} from './badges-overview.component';
import {BadgesOverviewHttpRepository} from './repositories/badges-overview.repository.http';
import {BadgesOverviewService} from './services/badges-overview.service';
import {BadgeModule} from 'shared/badges/components/badge-component/badge.module';

import {BadgesDetailsHttpRepository} from '../badges-details/repositories/badges-details.repository.http';
import {BadgesDetailsService} from '../badges-details/services/badges-details.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    BadgesOverviewRoutingModule,
    ModalConfirmationModule,
    SearchBarModule,
    BadgeModule,
  ],
  declarations: [
    BadgesOverviewComponent,
  ],
  providers: [
    BadgeTypeFactoryService,
    BadgesOverviewService,
    {
      provide: 'IBadgesOverviewRepository',
      useClass: BadgesOverviewHttpRepository,
    },
    BadgesDetailsService,
    {
      provide: 'IBadgesDetailsRepository',
      useClass: BadgesDetailsHttpRepository,
    },
  ],
})
export class BadgesOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-overview/badges-overview.module.ts